(() => {
  const init = (rootElement) => {
    if (!rootElement || rootElement.dataset.omvReady === 'true') return;
    rootElement.dataset.omvReady = 'true';

    const form = rootElement.querySelector('.omv-product-form');
    const input = rootElement.querySelector('[data-omv-quantity]');
    const variantInput = rootElement.querySelector('[data-omv-variant-input]');
    const submit = rootElement.querySelector('[data-omv-submit]');
    const submitText = rootElement.querySelector('[data-omv-submit-text]');
    const message = rootElement.querySelector('[data-omv-message]');
    const secondaryButtons = [...rootElement.querySelectorAll('[data-omv-add-again]')];
    const locale = rootElement.dataset.locale || 'ar';
    const english = locale.toLowerCase().startsWith('en');
    const routeRoot = (rootElement.dataset.root || '/').replace(/\/?$/, '/');
    let variants = [];
    try { variants = JSON.parse(rootElement.querySelector('[data-omv-variants]')?.textContent || '[]'); } catch (_) { /* Shopify form still works. */ }

    const money = (cents) => new Intl.NumberFormat(english ? 'en-US' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    const setMessage = (text, state = 'error') => {
      message.textContent = text;
      message.dataset.state = state;
    };
    const selectedVariant = () => variants.find(variant => String(variant.id) === String(variantInput.value));
    const syncVariant = () => {
      const variant = selectedVariant();
      if (!variant) return;
      rootElement.querySelectorAll('[data-omv-price], [data-omv-detail-price], [data-omv-sticky-price]').forEach(el => { el.textContent = money(variant.price); });
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      rootElement.querySelectorAll('[data-omv-compare-wrap], [data-omv-detail-compare-wrap], [data-omv-sticky-compare-wrap]').forEach(el => { el.hidden = !onSale; });
      if (onSale) rootElement.querySelectorAll('[data-omv-compare], [data-omv-detail-compare], [data-omv-sticky-compare]').forEach(el => { el.textContent = money(variant.compare_at_price); });
      const discount = rootElement.querySelector('[data-omv-discount]');
      if (discount) {
        discount.hidden = !onSale;
        if (onSale) discount.textContent = `${english ? 'Save' : 'خصم'} ${Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100)}%`;
      }
      const min = Math.max(1, Number(variant.quantity_rule?.min) || 1);
      const max = Number(variant.quantity_rule?.max) || null;
      input.min = String(min);
      if (max) input.max = String(max); else input.removeAttribute('max');
      if (Number(input.value) < min || (max && Number(input.value) > max)) input.value = String(min);
      submit.disabled = !variant.available;
      submitText.textContent = variant.available ? (english ? 'Add to cart' : 'أضف للسلة') : (english ? 'Sold out' : 'نفد المخزون');
      secondaryButtons.forEach(button => { button.disabled = !variant.available; });
      setMessage('', 'success');
    };
    variantInput.addEventListener('change', syncVariant);
    syncVariant();

    rootElement.querySelector('[data-omv-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(Number(input.min) || 1, (Number(input.value) || 1) - 1));
    });
    rootElement.querySelector('[data-omv-plus]')?.addEventListener('click', () => {
      const max = Number(input.max) || Infinity;
      input.value = String(Math.min(max, (Number(input.value) || 0) + 1));
    });
    secondaryButtons.forEach(button => button.addEventListener('click', () => {
      form.requestSubmit(submit);
    }));

    rootElement.querySelectorAll('[data-omv-thumb]').forEach(button => button.addEventListener('click', () => {
      const image = rootElement.querySelector('[data-omv-gallery-main] img');
      if (!image) return;
      image.src = button.dataset.src;
      image.srcset = '';
      image.alt = button.dataset.alt || '';
      rootElement.querySelectorAll('[data-omv-thumb]').forEach(thumb => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    }));

    const refreshAndOpenDrawer = async () => {
      const drawer = document.querySelector('hdt-cart-drawer[section-id]');
      const sectionId = drawer?.getAttribute('section-id');
      if (!sectionId) return false;
      const response = await fetch(`${routeRoot}?sections=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' });
      if (!response.ok) return false;
      const sections = await response.json();
      if (!sections[sectionId]) return false;
      const documentFragment = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const updated = documentFragment.getElementById(`shopify-section-${sectionId}`);
      const existing = document.getElementById(`shopify-section-${sectionId}`);
      if (!updated || !existing) return false;
      existing.replaceWith(updated);
      const cartResponse = await fetch(`${routeRoot}cart.js`, { credentials: 'same-origin' });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('hdt-cart-count').forEach(el => { el.textContent = String(cart.item_count); });
      }
      const trigger = document.querySelector('.hdt-site-nav_cart a[aria-controls="CartDrawer"]');
      trigger?.click();
      const dialog = document.getElementById('CartDrawer');
      if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      return Boolean(dialog?.open);
    };

    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return; // Native Shopify form is the fallback.
      event.preventDefault();
      if (submit.disabled) return;
      const quantity = Number(input.value);
      const min = Number(input.min) || 1;
      const max = Number(input.max) || Infinity;
      if (!Number.isInteger(quantity) || quantity < min || quantity > max) {
        setMessage(english ? 'Please check the quantity.' : 'يرجى التحقق من الكمية.');
        return;
      }
      submit.disabled = true;
      submit.classList.add('is-loading');
      secondaryButtons.forEach(button => { button.disabled = true; });
      setMessage('', 'success');
      try {
        const response = await fetch(`${routeRoot}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || (english ? 'Unable to add this item.' : 'تعذرت إضافة المنتج.'));
        setMessage(english ? 'Added to cart.' : 'تمت إضافة المنتج للسلة.', 'success');
        try {
          if (!await refreshAndOpenDrawer()) window.location.assign(`${routeRoot}cart`);
        } catch (_) {
          window.location.assign(`${routeRoot}cart`);
        }
      } catch (error) {
        setMessage(error.message || (english ? 'Please try again.' : 'يرجى المحاولة مرة أخرى.'));
      } finally {
        submit.classList.remove('is-loading');
        syncVariant();
      }
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-omv-section]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
